import { Component, Input, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { BrowserUploadedFile } from '../../models/uploaded-file.model';

@Component({
    selector: 'app-sm-file-upload-internal',
    templateUrl: './sm-file-upload-internal.component.html',
    styleUrls: [],
    standalone: false
})
export class SmFileUploadInternalComponent {

    _Arrays = Arrays;

    @Input()
    loadContents = true;
    @Input()
    acceptExtensions: string[] = null;
    @ViewChild('file')
    file: any;
    @Output()
    onFilesAdded: Subject<BrowserUploadedFile[]> = new Subject<BrowserUploadedFile[]>();

    async _onFilesAdded(): Promise<void> {
        let files: BrowserUploadedFile[] = [];
        const filesTemp: { [key: string]: File } = this.file.nativeElement.files;
        for (let key in filesTemp) {
            if (!isNaN(parseInt(key))) {
                files.push(new BrowserUploadedFile(filesTemp[key], null));
            }
        }

        if (this.loadContents) {
            await Promise.all(files.map(async file => new Promise((resolve, _reject) => {
                let fr = new FileReader();
                fr.onload = (e): void => {
                    file.contents = e.target.result as ArrayBuffer;
                    resolve(null);
                };
                fr.readAsArrayBuffer(file.legacy);
            })));
        }

        this.onFilesAdded.next(files);
    }
}
